import React, { useEffect, useState } from "react";
import {
  Region,
  IndicesData,
  IndicesPeerComparisonWidget,
  WidgetError,
  ThemeType,
  IndicesPeerComparisonWidgetProps,
  WidgetMessage,
  MarketIndex,
  WidgetHeightMessage,
  WidgetNameSource,
} from "@labci/bell-fg-widgets";
import { Spin } from "antd";
import CircularProgress from "../Components/CircularProgress/CircularProgress";

const IndicesPeerComparison: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const region = (queryParams.get("region") as Region) || Region.AU;
  const [index, setIndex] = useState(
    (queryParams.get("index") as MarketIndex) || "",
  );
  const token = queryParams.get("token") || "";
  const tab = queryParams.get("tab") || "";
  const theme = (queryParams.get("theme") as ThemeType) || ThemeType.Direct;

  useEffect(() => {
    window.addEventListener("message", (event) => {
      console.log("message", event);
      if (event.data && event.data.type === "index") {
        let msg = event.data as IndicesData;
        setIndex(msg.data.index as any);
      }
    });
    return () => {
      window.removeEventListener("message", (event) => {
        console.log("message", event);
      });
    };
  }, []);

  const handleCallback = (message: WidgetMessage) => {
    console.log("handleCallback", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(message),
        "*",
      );
      return;
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const handleNoData = (message: WidgetMessage) => {
    console.log("handleNoData", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
      return;
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const handleError = (error: WidgetError) => {
    console.log("handleError", error);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(error),
        "*",
      );
    }
    window.parent.postMessage(JSON.stringify(error), "*");
  };

  const handleLoadingChange = (loading: boolean) => {
    setIsLoading(loading);

    const loadingMessage = {
      type: "loading",
      value: loading,
      source: WidgetNameSource.IndicesPeerComparison,
    };
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(loadingMessage),
      );
      return;
    }
    window.parent.postMessage(JSON.stringify(loadingMessage), "*");
  };

  const handleHeightChange = (messages: WidgetHeightMessage) => {
    console.log("handleHeightChange", messages);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(messages));
      return;
    }
    window.parent.postMessage(JSON.stringify(messages), "*");
  };

  const props: IndicesPeerComparisonWidgetProps = {
    region: region,
    index: index,
    token: token,
    tab: tab,
    theme: theme,
    onCallback: handleCallback,
    onNoData: handleNoData,
    onError: handleError,
    onLoadingChange: handleLoadingChange,
    onHeightChange: handleHeightChange,
  };

  return (
    <Spin
      wrapperClassName="widget-spin"
      spinning={isLoading}
      indicator={<CircularProgress theme={theme as ThemeType} />}
    >
      <IndicesPeerComparisonWidget {...props} />
    </Spin>
  );
};

export default IndicesPeerComparison;
